import {
  Cloud,
  RefreshCw,
  Users,
  Smartphone,
  Download,
  WifiOff,
  Network,
  Share2,
} from 'lucide-react';
import { HubShell } from '@/components/layout/HubShell';
import CrossPlatformSync from './CrossPlatformSync';
import RealtimeSync from './RealtimeSync';
import CollaborativeSessionPage from './CollaborativeSession';
import MeshNetworkPage from './MeshNetwork';
import MobileCompanion from './MobileCompanion';
import MobileShare from './MobileShare';
import PWASettings from './PWASettings';
import OfflineMode from './OfflineMode';

/**
 * Sync hub — cross-device, realtime, collaboration, and mobile/PWA surfaces.
 */
export function SyncHubPage() {
  const tabs = [
    { id: 'sync', label: 'Sync', icon: Cloud, render: () => <CrossPlatformSync /> },
    { id: 'realtime', label: 'Realtime', icon: RefreshCw, render: () => <RealtimeSync /> },
    { id: 'collab', label: 'Collab', icon: Users, render: () => <CollaborativeSessionPage /> },
    { id: 'mesh', label: 'Mesh', icon: Network, render: () => <MeshNetworkPage /> },
    { id: 'mobile', label: 'Mobile', icon: Smartphone, render: () => <MobileCompanion /> },
    { id: 'share', label: 'Share', icon: Share2, render: () => <MobileShare /> },
    { id: 'pwa', label: 'PWA', icon: Download, render: () => <PWASettings /> },
    { id: 'offline', label: 'Offline', icon: WifiOff, render: () => <OfflineMode /> },
  ];

  return (
    <HubShell
      title="Sync & Share"
      description="Sync across devices, collaborate in real time, and use the mobile app."
      icon={Cloud}
      tabs={tabs}
      defaultSection="sync"
    />
  );
}

export default SyncHubPage;
